<footer class="footer">
  <ng-container *ngFor="let item of filteredMenuItems; trackBy: trackByFn">
    <a class="nav-item"
      itemprop="url"
      [routerLink]="(item.id === 'class' || item.id === 'create-widget') ? null : item.route"
      [queryParams]="getQueryParams()"
      routerLinkActive="active"
      [class.active2]="isActiveRoute(item)"
      (click)="(item.id === 'class' || item.id === 'create-widget') ? toggleCreateModal() : showCreatePopup=false">
      <app-icon class="nav-item-icon" [ngClass]="item.id" [file]="isMeVersion() ? 'header' : 'sidebar-mobile-new'" [icon]="item.icon"></app-icon>
      {{ item.label | translate }}
    </a>
  </ng-container>
  <div [ngStyle]="{'display': showCreatePopup ? 'block' : 'none'}" class="event-create-popup" [class.web-version]="!isMeVersion()">
    <div class="options-block">
      <ng-container *ngIf="isMeVersion()">
        <div class="option blue" *ngIf="quickMeetingVisible" (click)="onQuickMeeting()">
          <div class="icon">
            <app-icon [width]="30" [height]="30" file="sidebar" icon="sidebar-quick-class"></app-icon>
          </div>
          <p class="label">{{'menu.left-sidebar.study-create' | translate}}</p>
        </div>
        <div class="option" *ngIf="scheduleMeetingVisible" (click)="onScheduleMeeting()">
          <div class="icon">
            <app-icon [width]="30" [height]="30" file="sidebar" icon="sidebar-schedule-class"></app-icon>
          </div>
          <p class="label">{{'my-classes.actions.schedule-class' | translate}}</p>
        </div>
      </ng-container>

      <ng-container *ngIf="!isMeVersion()">
        <app-left-sidebar [showAdditionalMenu]="true" [floating]="false"
                          (onClickItem)="showCreatePopup=false"></app-left-sidebar>
      </ng-container>
    </div>
  </div>
</footer>

<div *ngIf="showCreatePopup" (click)="showCreatePopup=false" class="shade"></div>

<ng-template [ngIf]="meetingFormOpened">
  <app-modal *ngIf="!deviceService.isMobile()" (closed)="closeMeetingForm()">
    <app-modal-body>
      <app-meeting-form-wrapper (saved)="closeMeetingForm()" [caller]="'app-footer'"></app-meeting-form-wrapper>
    </app-modal-body>
  </app-modal>

  <app-mobile-modal *ngIf="deviceService.isMobile()" (closed)="closeMeetingForm()">
    <app-mobile-modal-title>{{ 'lingo2-forms.meetings.form-title' | translate }}</app-mobile-modal-title>
    <app-mobile-modal-body>
      <app-meeting-form-wrapper (saved)="closeMeetingForm()" [caller]="'app-footer'"></app-meeting-form-wrapper>
    </app-mobile-modal-body>
  </app-mobile-modal>
</ng-template>

